/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  AssignDeviceModelIncidentRuleDto,
  CreateIncidentRuleDto,
  DeviceModelIncidentRulesControllerAssignV1200,
  DeviceModelIncidentRulesControllerAssignV1PathParameters,
  DeviceModelIncidentRulesControllerCreateV1201,
  DeviceModelIncidentRulesControllerCreateV1PathParameters,
  DeviceModelIncidentRulesControllerDeleteV1PathParameters,
  DeviceModelIncidentRulesControllerFindAllV1200AllOf,
  DeviceModelIncidentRulesControllerFindAllV1Params,
  DeviceModelIncidentRulesControllerFindAllV1PathParameters,
  DeviceModelIncidentRulesControllerFindOneV1200,
  DeviceModelIncidentRulesControllerFindOneV1PathParameters,
  DeviceModelIncidentRulesControllerUpdateV1200,
  DeviceModelIncidentRulesControllerUpdateV1PathParameters,
  UpdateIncidentRuleDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceModelIncidentRulesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Copy one model incident rule template to all devices of this model (skips existing identical device rules)
   */

  assign<TData = DeviceModelIncidentRulesControllerAssignV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId }: DeviceModelIncidentRulesControllerAssignV1PathParameters,
    assignDeviceModelIncidentRuleDto: AssignDeviceModelIncidentRuleDto,
  ): Observable<TData> {
    return this.http.post<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules/assign`,
      assignDeviceModelIncidentRuleDto,
    );
  }
  /**
   * @summary Create a default incident rule on a device model
   */

  create<TData = DeviceModelIncidentRulesControllerCreateV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId }: DeviceModelIncidentRulesControllerCreateV1PathParameters,
    createIncidentRuleDto: CreateIncidentRuleDto,
  ): Observable<TData> {
    return this.http.post<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules`,
      createIncidentRuleDto,
    );
  }
  /**
   * @summary List default incident rules for a device model
   */

  findAll<TData = DeviceModelIncidentRulesControllerFindAllV1200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId }: DeviceModelIncidentRulesControllerFindAllV1PathParameters,
    params?: DeviceModelIncidentRulesControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Get one device model incident rule
   */

  findOne<TData = DeviceModelIncidentRulesControllerFindOneV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    makerId,
    modelId,
    ruleId,
  }: DeviceModelIncidentRulesControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules/${ruleId}`,
    );
  }
  /**
   * @summary Update a device model incident rule (does not sync to existing devices)
   */

  update<TData = DeviceModelIncidentRulesControllerUpdateV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId, ruleId }: DeviceModelIncidentRulesControllerUpdateV1PathParameters,
    updateIncidentRuleDto: UpdateIncidentRuleDto,
  ): Observable<TData> {
    return this.http.put<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules/${ruleId}`,
      updateIncidentRuleDto,
    );
  }
  /**
   * @summary Delete a device model incident rule template (does not remove device-level rules)
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    makerId,
    modelId,
    ruleId,
  }: DeviceModelIncidentRulesControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules/${ruleId}`,
    );
  }
}
